export const fashionModelAcceptControlTerms = `
  <div>
    By hitting &lsquo;I accept&rsquo;, I fully understand and accept the
    contents of the
    <a
      href="https://www.ctribefestival.com/model-release"
      class="text-blue-500"
      target="_blank"
      rel="noopener noreferrer"
    >
    C-Tribe Model Release Form
    </a>
    and the
    <a
      href="https://www.ctribefestival.com/terms-of-service"
      class="text-blue-500"
      target="_blank"
      rel="noopener noreferrer"
    >
    Terms of Service</a>, and have read the
    <a
      href="https://www.ctribefestival.com/privacy"
      class="text-blue-500"
      target="_blank"
      rel="noopener noreferrer"
    >
    Privacy Policy</a>.
  </div>`;
